import { IClientReport } from "../types";

// TODO add `:IReport` after cobrand and enhancedLoans are removed from IReport
// NOTE properties, loans, and debts are filtered based on the report and will be an array of the object instead of id
export function getReportWithObjects(client: any, report: IClientReport) {
    return {
        ...report,
        properties: client.properties.filter(
            ({ id }: any) => report.properties && report.properties.includes(id),
        ),
        loans: report.loans
            ? (() => {
                  const loanMap = new Map(client.loans.map((loan: any) => [loan.id, loan]));
                  // Get loans in the order they appear in the report
                  return report.loans.map((loanId: any) => loanMap.get(loanId)).filter(Boolean);
              })()
            : [],
        debts: client.debts?.filter(({ id }: any) => report.debts && report.debts.includes(id)),
        clientVersion: client.version,
    };
}
